import { FolderIcon, StarIcon, ArrowUpTrayIcon, ArrowDownTrayIcon, BriefcaseIcon } from '@heroicons/react/24/solid';
import { MagnifyingGlassIcon, StarIcon as OutlineStarIcon } from '@heroicons/react/24/outline';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useSession } from 'contexts';
import { GetDocumentsDocument, UpdateDocumentDocument } from 'graphql/generated';
import { useMutation, useQuery } from '@apollo/client';
import Flyout, { useFlyout } from 'components/Flyout/Flyout';
import { DocumentsView } from 'components/Documents/Documents';
import Button from 'components/Button/Button';
import Paywall from 'components/Paywall/Paywall';
import DragAndDrop from './Components/DragAndDrop';
import Toast, { ToastLength, useToast } from 'components/Toast/Toast';
import { AbilityContext } from 'contexts/AbilityContext';
import { permissionHandler } from 'utils/PermissionHandler';
import sanitizeQuery from 'utils/querySanitizer';
import Header from 'components/Header/Header';
import SimpleSearch from 'components/SimpleSearch/SimpleSearch';
import ThumbButton from 'components/ThumbButton/ThumbButton';

const maxSize = 250 * 1024 * 1024; // Max Upload File 250MB in bytes
export const imageMime = 'image/jpeg, image/png, image/gif, application/pdf, image/heic, image/heif';
const Documents = function () {  
  const { flyoutProps, updateFlyout, closeFlyout } = useFlyout();
  const { craftId, organizationSubtype } = useSession();
  const [ query, setQuery ] = useState('');
  const { toastProps, showToast } = useToast();
  const { data : { documents = [] } = {}, refetch, loading } = useQuery( GetDocumentsDocument, { variables: { where: { craftId :{ equals: craftId }, ...(query &&  {name: { startsWith: sanitizeQuery(query) }} ) } } } );
  const ability = useContext(AbilityContext);
  const canManageDocuments = permissionHandler('Manage Aircraft Documents', ability);
  const uploadButton = useRef(null);  
  const uploadDocument = async(event) => {
    const formData = new FormData();
    const files = Array.from(event.target.files) as File[];
    files.forEach((file) => {
      if (file.size > maxSize) {
        alert('File(s) size exceeds the 250MB limit.');
        return;
      }
      formData.append('files', file);
    });
    uploadButton.current.value = '';
    formData.append('craftId', craftId );
    const res = await fetch(process.env.REACT_APP_API_URL + '/attachments/upload', { method: 'POST', body: formData });
    if (res.ok) {
      showToast({ title: 'File uploaded successfully', type: ToastLength.Normal});
      refetch();
    }else{
      console.log(res);
    }
  };

  

  return (
    <>
      <Toast {...toastProps} position='top' />
      <Flyout { ...flyoutProps } />
      <DragAndDrop className='flex flex-col' field="craftId" enabled={canManageDocuments} id={craftId} refetch={refetch} showToast={showToast}>
        {/* Header */}
        <Header title="Documents" icon={BriefcaseIcon}>
          {organizationSubtype !== 'FREE' && 
            <>
              <SimpleSearch query={query} setQuery={setQuery} className="mt-2 pt-2 border-t border-slate-200 w-full order-3 lg:order-2 lg:mt-0 lg:mr-2 lg:pt-0 lg:border-t-0 lg:w-auto" />
              { canManageDocuments && 
                <>
                  <div className="hidden md:block order-2 lg:order-3">
                    <Button text="Upload" color="navy" size="xs" icon={<ArrowUpTrayIcon className="h-3 w-3 mr-1" />} onClick={() => uploadButton.current.click()} /> 
                  </div>
                  <ThumbButton size="primary" role="upload" onClick={() => uploadButton.current.click()} />
                </>
              }
              <input
                type="file"
                ref={uploadButton}
                onChange={uploadDocument}
                style={{ display: 'none' }}
                accept={imageMime} 
              />
            </>
          }
        </Header>
        {/* Body */}
        {organizationSubtype === 'FREE' ? 
          <Paywall /> :
          <DocumentsView {...{ closeFlyout, updateFlyout, data: (documents as any), canManageDocuments }}  />
        }
      </DragAndDrop>
    </> 
  );
};

export default Documents;
